import {events} from '@scripts/consts/events';

export function sendMetrics(options) {
    document.dispatchEvent(new CustomEvent(events.metrics, {
        detail: options,
    }));
}
